var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLimitsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_45_2",
    "data-name": "Component 45 \\u2013 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_83337",
    "data-name": "Path 83337",
    d: "M23,0C40.851,0,46,5.149,46,23S40.851,46,23,46,0,40.851,0,23,5.149,0,23,0Z",
    fill: "#f2f3f7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bar-chart-2",
    transform: "translate(12 12)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_481",
    "data-name": "Line 481",
    y1: 8.75,
    transform: "translate(16 9.25)",
    fill: "none",
    stroke: "#636974",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_482",
    "data-name": "Line 482",
    y1: 14,
    transform: "translate(11 4)",
    fill: "none",
    stroke: "#636974",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_483",
    "data-name": "Line 483",
    y1: 5.25,
    transform: "translate(6 12.75)",
    fill: "none",
    stroke: "#636974",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLimitsIcon);
export default __webpack_public_path__ + "static/media/limits_icon.265966ffd28678d96e7c68aa6582b3d6.svg";
export { ForwardRef as ReactComponent };